import { Link } from 'react-router-dom';
import { getCategoryName } from '@/mocks/movies';

interface MovieCardProps {
  id: string;
  title: string;
  poster: string;
  year: number;
  category: string;
  rating: number;
  duration: string;
  slug: string;
}

export default function MovieCard({
  id,
  title,
  poster,
  year,
  category,
  rating,
  duration,
  slug,
}: MovieCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-100 mb-3">
        <img
          src={poster}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={`${title} - 555影视`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-white text-xs line-clamp-2">
            点击查看{title}详情
          </p>
        </div>
        <div className="absolute top-2 right-2 bg-black/70 backdrop-blur-sm text-accent-500 text-xs font-bold px-2 py-0.5 rounded-md">
          {rating}
        </div>
        {year === 2026 && (
          <div className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-md">
            NEW
          </div>
        )}
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
        {title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span className="bg-background-100 px-1.5 py-0.5 rounded">{getCategoryName(category)}</span>
        <span>{year}</span>
        <span>{duration}</span>
      </div>
    </Link>
  );
}